"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.controller = controller;
exports.application = application;
exports.parameters = parameters;
exports.schema = schema;
const NoTransformConfigurationError_1 = require("./transformers/NoTransformConfigurationError");
/** @internal */
function controller(..._args) {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("llm.controller");
}
/** @internal */
function application() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("llm.application");
}
/** @internal */
function parameters() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("llm.parameters");
}
/** @internal */
function schema() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("llm.schema");
}
//# sourceMappingURL=llm.js.map